import { PayloadAction } from '@reduxjs/toolkit';
import React from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { RootState } from '../../app/store';
import { SearchBar } from './SearchBar';

type ReduxSearchBar = {
  selectReduxItem: (state: RootState) => string;
  updateRedux: (val: string) => PayloadAction<string>; // The update function for the redux slice
};

export const ReduxSearchBar: React.FC<ReduxSearchBar> = ({
  selectReduxItem,
  updateRedux,
}) => {
  const dispatch = useAppDispatch();
  const initialSearchValue = useAppSelector(selectReduxItem);

  const handleChange = (newSearchVal: string) => {
    dispatch(updateRedux(newSearchVal));
  };

  return (
    <SearchBar initialValue={initialSearchValue} onChange={handleChange} />
  );
};
